import React, { useState } from "react";
import RichTextEditor from "react-rte";
import "react-rte/lib/RichTextEditor.css";

const TextEditor = ({ initialValue, onChange, placeholder }) => {
  // Create an empty editor value to start with
  const [editorValue, setEditorValue] = useState(() => {
    // If we have initial content, convert it from raw format to RTE format
    if (initialValue) {
      try {
        return RichTextEditor.createValueFromString(initialValue, "html");
      } catch (error) {
        console.error("Error parsing initial value:", error);
      }
    }
    // Otherwise create an empty value
    return RichTextEditor.createEmptyValue();
  });

  // Handle changes to the editor
  const handleChange = (value) => {
    setEditorValue(value);

    // Call parent onChange handler with HTML string for MongoDB storage
    if (onChange) {
      onChange(value.toString("html"));
    }
  };

  // Custom toolbar configuration with undo/redo buttons
  const toolbarConfig = {
    display: ["INLINE_STYLE_BUTTONS", "HISTORY_BUTTONS"],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD" },
      { label: "Italic", style: "ITALIC" },
      { label: "Underline", style: "UNDERLINE" },
    ],
    HISTORY_BUTTONS: [
      { label: "Undo", style: "UNDO" },
      { label: "Redo", style: "REDO" },
    ],
  };

  return (
    <div className="text-editor-container">
      <RichTextEditor
        value={editorValue}
        onChange={handleChange}
        toolbarConfig={toolbarConfig}
        placeholder={placeholder}
        className="story-writing-area"
      />
      <style jsx>{`
        .text-editor-container {
          position: relative;
          width: 100%;
        }
        .story-writing-area {
          min-height: 500px;
          width: 100%;
          border: 1px solid #ddd;
          border-radius: 4px;
        }
        /* Adjust React-RTE toolbar styles */
        :global(.RichTextEditor__root) {
          border-radius: 10px;
        }
        :global(.public-DraftEditor-content) {
          min-height: 280px;
        }
        /* Normal state - light shade of #0c343a */
        :global(.RichTextEditor__toolbar button) {
          color: #3a7a85;
        }
        /* Hover state */
        :global(.RichTextEditor__toolbar button:hover) {
          background-color: rgb(116, 147, 178);
          color: #ffffff;
        }
        /* Active state - medium shade between normal and dark */
        :global(.RichTextEditor__activeButton) {
          background-color: #1d5661 !important;
          color: #ffffff !important;
        }
        :global(.RichTextEditor__toolbar) {
          border-bottom: 1px solid #ddd;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          background-color: #f5f8fa;
        }
      `}</style>
    </div>
  );
};

export default TextEditor;
